











import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { setDevJWT, parseJWT } from '@/lib/helpers/common.helper';
import { ERole } from '@/lib/enums';

@Component
export default class DevScreen extends Vue {
  public devRoles: ERole[] = [];
  public roles: string[] = Object.keys(ERole);

  public roleChanged(event: Event) {
    setDevJWT(this.devRoles);
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    const jwt = parseJWT();
    next((vm: DevScreen) => {
      if (jwt) {
        vm.devRoles = jwt.roles;
      }
    });
  }
}
